import React from 'react'

export interface Props {
  ItemClass?: any;
  ItemId?: any;
  children?: any;
  listStyle?: React.CSSProperties;
}

export const ListItem = ({
  ItemClass,
  ItemId,
  children,
  listStyle
}:Props) => {
  return (
    <li style={listStyle && listStyle} className={ItemClass} id={ItemId}>
      {children}
    </li>
  )
}

export default ListItem;
